import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import cutPlayerCard from './assets/cutPlayerCard.webp';
import footballCutPlayerCard from './assets/footballCutPlayerCard.webp';

/*
 * display rounded cash prize values no matter the currency
 */
export const ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY = 2000;

export const getCutPlayerCard = (sport: Sport) => {
  switch (sport) {
    case Sport.NBA:
      return cutPlayerCard;
    case Sport.BASEBALL:
      return cutPlayerCard;
    case Sport.FOOTBALL:
    default:
      return footballCutPlayerCard;
  }
};

export const useScoreAverageCountBySport = (): Record<Sport, string> => {
  const {
    flags: { useLastTenPlayedAverageAsDefault = false },
  } = useFeatureFlags();
  return {
    [Sport.NBA]: '10',
    [Sport.FOOTBALL]: useLastTenPlayedAverageAsDefault ? '10' : '15',
    [Sport.BASEBALL]: '10',
  };
};
